export const AUCTION_DEFAULTS = {
    unit_price: 10,
    min_price: 2,
    max_price: 40,
    x_multiplier: 1,
    recommended: 1.5
}